import { useConflictResolutionKey } from '@tunasong/graph-lib/react'
import { capitalize, dayjs } from '@tunasong/models'
import { getPlugin, usePlugins } from '@tunasong/plugin-lib'
import type { SidebarComponent } from '@tunasong/ui-lib'
import { Divider, ElementForm, EntityConflictBanner, fieldsWithOwnPanel, HBox, Typography } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './sidebar-settings.module.css'

export const SidebarSettings: FC<SidebarComponent> = ({ entity, onEntityChange }) => {
  const plugins = usePlugins('all')
  const EntityProperties = entity ? getPlugin(entity, plugins)?.components?.Properties : null
  /**
   * The form and the properties keep their values in uncontrolled inputs and local drafts (a poll's option and group
   * names, a date poll's slots). "Use their version" and its Undo replace the value under them, so they remount on
   * this key and show it (GH #1912).
   */
  const resolution = useConflictResolutionKey(entity.id)
  const editorKey = `${entity.id}:${resolution}`

  return (
    <div className={styles.root} key={entity.id}>
      {/* GH #1912: tags and the item's properties; the fields with a panel of their own show there */}
      <EntityConflictBanner entityId={entity.id} exclude={fieldsWithOwnPanel} />
      <ElementForm key={editorKey} element={entity} onChange={onEntityChange} />
      {EntityProperties ? (
        <>
          <Divider className={styles.divider}>
            <Typography variant="caption">{capitalize(entity.type)} properties</Typography>
          </Divider>
          <EntityProperties key={editorKey} element={entity} onChange={onEntityChange} />
        </>
      ) : null}
      <Divider className={styles.divider} />
      <div className={styles.metaSection}>
        <HBox className={styles.metaRow}>
          <Typography variant="caption">Created</Typography>
          <Typography variant="caption"> {dayjs(entity.createdAt).format('LL')}</Typography>
        </HBox>
        <HBox className={styles.metaRow}>
          <Typography variant="caption">Last updated</Typography>
          <Typography variant="caption">{dayjs(entity.updatedAt).format('LL')}</Typography>
        </HBox>
      </div>
    </div>
  )
}
